import * as _4 from 'lodash4';
import { TAppointmentAvailableTimesUsersource } from '../usersources/appointment_available_times_usersource';
import { TAppointmentLocationsOrganizersUsersource } from '../usersources/appointment_location_staff_usersource';
import { TAppointmentReasonUsersource } from '../usersources/appointment_reason_usersource';

export class AppointmentUsersourceServant {
  constructor(
    private ngAppointmentAvailableTimesUsersource: TAppointmentAvailableTimesUsersource,
    private ngAppointmentLocationsOrganizersUsersource: TAppointmentLocationsOrganizersUsersource,
    private ngAppointmentReasonUsersource: TAppointmentReasonUsersource
  ) {}

  get isUserBlocked(): boolean {
    const locationBlocked = this.ngAppointmentLocationsOrganizersUsersource.read().selectedLocation.is_blocked
      ? this.ngAppointmentLocationsOrganizersUsersource.read().selectedLocation.is_blocked
      : false;
    return this.ngAppointmentReasonUsersource.read().selectedType.is_blocked || locationBlocked;
  }

  get canUserSchedule(): boolean {
    return this.ngAppointmentLocationsOrganizersUsersource.read().selectedLocation.can_schedule;
  }

  get canUserViewWalkins(): boolean {
    return this.ngAppointmentLocationsOrganizersUsersource.read().selectedLocation.can_view_dropins;
  }

  get canUserRequest(): boolean {
    if (_4.has(this.ngAppointmentLocationsOrganizersUsersource.read().selectedLocation, 'can_request')) {
      return this.ngAppointmentLocationsOrganizersUsersource.read().selectedLocation.can_request;
    }
    return this.ngAppointmentReasonUsersource.read().selectedType.can_request;
  }

  get errorBlockedText(): string {
    return this.ngAppointmentLocationsOrganizersUsersource.read().selectedLocation.blocked_reason
      ? this.ngAppointmentLocationsOrganizersUsersource.read().selectedLocation.blocked_reason
      : this.ngAppointmentReasonUsersource.read().selectedType.blocked_reason;
  }

  getErrorMessageText(fallbackMessage: string): string {
    if (this.isUserBlocked) {
      return this.errorBlockedText;
    }
    return fallbackMessage;
  }

  get isUserAllowedRoChooseOrganizer() {
    const selectedService = this.ngAppointmentReasonUsersource.read().selectedService;
    const selectedLocation = this.ngAppointmentLocationsOrganizersUsersource.read().selectedLocation;

    if (_4.has(selectedLocation, 'deny_students_to_choose_organizer')) {
      return !selectedLocation.deny_students_to_choose_organizer;
    }

    return !selectedService.deny_students_to_choose_organizer;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/servants/appointments_usersource_servant.ts